import { Autocomplete, Button, Grid, Paper, Space, Text, Box, Group, Flex } from '@mantine/core'
import classes from './ManageDbVersion.module.css'
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";
import { IoMdCloudUpload } from "react-icons/io";
import React, { memo, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import InputButton from '../../../CustomComponent/InputFileButton/Inputbutton.component';
import { baseUrl } from '../../../Constants/constant';
import TableDbVersionComponent from './TableDbVersion.component';

const ManageVerticals = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <>

      <Paper shadow="xs" p="xs" radius="md">
        <Box>
           <Flex
                     style={{justifyContent:'space-between'}}
                     align="center"
                     >
                      <Box>
              <Text ta="left">DataBase Version</Text>
            </Box>
            <Group>
              <Autocomplete
                // label="Your favorite library"
                value={search}
                onChange={handlechange}
                placeholder="Search by keywords"
                leftSection={<IoMdSearch />}
              />

              <Button
                className={classes.addbtn}
                variant="gradient"
                gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                leftSection={<IoAdd size={20} />}
                onClick={() => navigate('/manage-db-version/add-db-version')}
              >
                Add DataBase Version
              </Button>
                {/* <InputButton
                  url={`${baseUrl}admin/verticals/import-file`}
                /> */}
            </Group>
          </Flex>
          <TableDbVersionComponent editLink={'/manage-db-version/add-db-version'} search={sendsearch} />
        </Box>
      </Paper>
    </>
  )
}

export default memo(ManageVerticals)
